import { AnimatePresence, motion } from 'framer-motion'

export default function HeroSectionPreview({ heroImages, heroIdx, setHeroIdx, flashing, playing, togglePlay }) {
  return (
    <section className="relative overflow-hidden rounded-none sm:rounded-lg border bg-gray-900">
      <div className="relative aspect-[16/9] sm:aspect-auto sm:h-[80vh]">
        <AnimatePresence mode="wait">
          <motion.div
            key={heroIdx}
            className="absolute inset-0"
            initial={{ opacity: 0, scale: 1 }}
            animate={{ opacity: 1, scale: flashing ? 1.05 : 1.1 }}
            exit={{ opacity: 0, scale: 1.15 }}
            transition={{ duration: 0.3 }}
          >
            <div
              className="h-full w-full bg-cover bg-center"
              style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url('${heroImages[heroIdx]}')` }}
            />
          </motion.div>
        </AnimatePresence>

        <AnimatePresence>
          {flashing && (
            <motion.div
              className="absolute inset-0 z-20 bg-gray-100"
              initial={{ opacity: 0 }}
              animate={{ opacity: [0, 0.8, 0] }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3, times: [0, 0.5, 1] }}
            />
          )}
        </AnimatePresence>

        {/* Side Banner */}
        <div className="absolute hidden md:block w-fit h-fit inset-0 top-1/2 -left-16 lg:-left-20 bg-blue-600 text-white p-1 px-2 -rotate-90 origin-right transform -translate-y-1/2 -translate-x-8 lg:-translate-x-12 z-10">
          <span className="text-xs lg:text-sm font-medium whitespace-nowrap">ASA HIKARI MULYA 2025</span>
        </div>

        {/* Main Content */}
        <div className="relative z-10 h-full flex flex-col justify-center items-center text-center text-white px-4 sm:px-6 md:px-8">
          <div className="mx-auto space-y-3 sm:space-y-4 md:space-y-6 max-w-3xl">
            <div className="flex items-center justify-center gap-2 sm:gap-4 md:gap-6">
              <div className="flex-grow border-t border-gray-100 opacity-10 max-w-[40px] xs:max-w-8 sm:max-w-none" />
              <div className="flex flex-col text-3xl xs:text-xl sm:text-2xl md:text-3xl lg:text-5xl xl:text-6xl font-bold leading-tight">
                <span>Asa</span><span>Hikari</span><span>Mulya</span>
              </div>
              <div className="flex-grow border-t border-gray-100 opacity-10 max-w-[40px] xs:max-w-8 sm:max-w-none" />
            </div>
            <p className="text-xs xs:text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl mb-0 font-semibold italic px-3 sm:px-4 md:px-10 leading-tight opacity-90">
              &quot;Kami siap memberikan bimbingan dan segala hal yang perlu Anda ketahui untuk mempersiapkan diri bekerja di Jepang&quot;
            </p>
            <p className="text-xs xs:text-sm sm:text-base md:text-lg lg:text-xl mt-2 max-w-xs xs:max-w-sm sm:max-w-xl md:max-w-2xl lg:max-w-3xl mx-auto leading-relaxed px-3 sm:px-4 opacity-75">
              Asa Hikari Mulya adalah pusat pelatihan bahasa Jepang terpercaya yang mempersiapkan Anda untuk bekerja di Jepang melalui program SSW dan Magang.
            </p>
            <button className="rounded-bl-2xl rounded-tr-2xl bg-blue-800 w-3/4 xs:w-2/3 sm:w-1/2 h-10 sm:h-12 text-sm xs:text-base sm:text-lg font-semibold hover:bg-blue-700 transition-all inline-flex items-center justify-center gap-2 sm:hidden">
              Join Now
            </button>
          </div>
        </div>

        {/* Dots */}
        {heroImages.length > 1 && (
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1">
            {heroImages.map((_, i) => (
              <button key={i} onClick={() => setHeroIdx(i)} className={`rounded-full transition-all ${i === heroIdx ? 'w-4 h-1.5 bg-white' : 'w-1.5 h-1.5 bg-white/40'}`} />
            ))}
          </div>
        )}
      </div>
    </section>
  )
}
